import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=3d5aefef&scoped=true&"
import script from "./user-edit.vue?vue&type=script&lang=js&"
export * from "./user-edit.vue?vue&type=script&lang=js&"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=3d5aefef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5aefef",
  null
  
)

export default component.exports